/**
 * tabs 系の共通ストア。tab-buttons / tab-panels で同一 namespace を使う。
 *
 * NOTE: data-wp-class / data-wp-bind は PHP プロセッサが JS getter を評価できず
 * SSR で付けたクラス／属性を削除してしまうことがあるため、active 状態の同期は
 * data-wp-watch コールバックで行う（PHP プロセッサは通り抜ける）。
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const { state } = store('best-anniversary-blocks/tabs', {
	state: {
		groups: {},
	},
	actions: {
		activate(event) {
			if (event && typeof event.preventDefault === 'function') {
				event.preventDefault();
			}
			const { groupId, index } = getContext();
			state.groups[groupId] = index;
		},
		handleKeydown(event) {
			const key = event.key;
			if (
				key !== 'ArrowLeft' &&
				key !== 'ArrowRight' &&
				key !== 'Home' &&
				key !== 'End'
			) {
				return;
			}
			event.preventDefault();

			const { groupId } = getContext();
			const tabs = Array.from(
				document.querySelectorAll(
					`[role="tab"][data-tabs-group-id="${groupId}"]`
				)
			);
			if (tabs.length === 0) {
				return;
			}

			const idx = tabs.indexOf(getElement().ref);
			let next = idx;
			if (key === 'ArrowLeft') {
				next = (idx - 1 + tabs.length) % tabs.length;
			} else if (key === 'ArrowRight') {
				next = (idx + 1) % tabs.length;
			} else if (key === 'Home') {
				next = 0;
			} else if (key === 'End') {
				next = tabs.length - 1;
			}

			const nextTab = tabs[next];
			if (nextTab) {
				nextTab.focus();
				nextTab.click();
			}
		},
	},
	callbacks: {
		syncPanel() {
			const { groupId, index } = getContext();
			const isActive = state.groups[groupId] === index;
			const el = getElement().ref;
			if (!el) {
				return;
			}
			el.classList.toggle('is-active', isActive);
			el.setAttribute('aria-hidden', String(!isActive));
		},
		syncTab() {
			const { groupId, index } = getContext();
			const isActive = state.groups[groupId] === index;
			const el = getElement().ref;
			if (!el) {
				return;
			}
			el.classList.toggle('is-active-tab', isActive);
			el.setAttribute('aria-selected', String(isActive));
			el.setAttribute('tabindex', isActive ? '0' : '-1');
		},
	},
});
